import { render, staticRenderFns } from "./Maintenance.vue?vue&type=template&id=98296492&scoped=true&"
import script from "./Maintenance.vue?vue&type=script&lang=js&"
export * from "./Maintenance.vue?vue&type=script&lang=js&"
import style0 from "./Maintenance.vue?vue&type=style&index=0&id=98296492&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98296492",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98296492')) {
      api.createRecord('98296492', component.options)
    } else {
      api.reload('98296492', component.options)
    }
    module.hot.accept("./Maintenance.vue?vue&type=template&id=98296492&scoped=true&", function () {
      api.rerender('98296492', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/system/Maintenance.vue"
export default component.exports